import React from "react";
import { COMING_SOON_NOTICE,ALERT_COLOR } from "../constants";

const ComingSoonNavbar = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        backgroundColor: "white",
        fontWeight: "bold",
      }}
    >
      {/* Main blinking notice */}
      <div
        style={{
          color: ALERT_COLOR,
          fontSize: "26px",
          animation: "blink 3s infinite", // Blink every 3 seconds
        }}
      >
        {COMING_SOON_NOTICE}
      </div>

      {/* Description text below the notice */}
      <p
        style={{
          marginTop: "10px",
          fontSize: "18px",
          fontWeight: "normal",
          color: "#333",
        }}
      >
        We’re building a platform where you can practice English speaking via
        live video calls with tutors and peers — all at very affordable prices!
      </p>

      {/* Blink animation keyframes */}
      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default ComingSoonNavbar;

